import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
export class FormlyWrapperFieldset extends FieldWrapper {
   fieldComponent: ViewContainerRef;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-wrapper-fieldset',
  template: `
    <div class="form-group">
      <ng-template #fieldComponent></ng-template>
    </div>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fieldComponent': [{ type: ViewChild, args: ['fieldComponent', {read: ViewContainerRef}, ] },],
};
}

function FormlyWrapperFieldset_tsickle_Closure_declarations() {
/** @type {?} */
FormlyWrapperFieldset.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyWrapperFieldset.ctorParameters;
/** @type {?} */
FormlyWrapperFieldset.propDecorators;
/** @type {?} */
FormlyWrapperFieldset.prototype.fieldComponent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
